const SELECT_ALL_NAME = "Select All";

export const filterOptions = <T extends { name: string }>(
  options: T[] | undefined,
  state: { inputValue: string; getOptionLabel?: () => string }
): T[] => {
  return (
    options?.filter(option => {
      return (
        option.name === SELECT_ALL_NAME ||
        option.name.toLowerCase().includes(state.inputValue.toLowerCase())
      );
    }) ?? []
  );
};
